<template>

</template>
<script>
import MUTATION_EXCHANGE_OUTLOOK_CODE_BASIC from "@/gql/mutations/exchangeOutlookCodeBasic.graphql";
import MUTATION_EXCHANGE_OUTLOOK_CODE_FULL from "@/gql/mutations/exchangeOutlookCodeFull.graphql";
import {gqlMutation} from "@/gqlClient";
import {generatePKCE} from "@/utils/pkce";

export default {
  name: "CallBackOutlook",

  data() {
    return {
      loading: true,
      error: null,
      success: false,
    };
  },

  async mounted() {
    const query = this.$route.query;
    const configId = query.state;
    const code = query.code;
    console.log(query);
    const codeVerifier = sessionStorage.getItem("outlook_pkce_verifier");
    const step = sessionStorage.getItem("outlook_step");

    if (!configId || !code || !codeVerifier) {
      this.error = "Paramètres manquants pour la connexion Outlook.";
      this.loading = false;
      return;
    }

    try {
      if (step === "email") {
        await gqlMutation(MUTATION_EXCHANGE_OUTLOOK_CODE_BASIC, {"code": code, "code_verifier": codeVerifier, "config_id": configId})

        this.launchImapFullConsent(configId);

      } else if (step === "imap") {
        // --- ÉTAPE 2 : On récupère IMAP/SMTP token ---
        await gqlMutation(MUTATION_EXCHANGE_OUTLOOK_CODE_FULL, {"code": code, "code_verifier": codeVerifier, "config_id": configId})

        this.success = true;
        this.loading = false;
        // Nettoyage des steps/session
        sessionStorage.removeItem("outlook_step");
        sessionStorage.removeItem("outlook_used_code");
        sessionStorage.removeItem("outlook_pkce_verifier");
        // Redirige vers /webmail après succès
        this.$router.replace("/webmail");
      }

    } catch (e) {
      this.error = e.message || "Erreur lors du traitement Microsoft.";
      this.loading = false;
    }
  },

  methods: {
    launchImapFullConsent(configId) {
      const tenantId = "common";
      const clientId = "cf7412b8-9395-4441-97ad-d1858666a286";

      // PKCE again
      generatePKCE().then(({code_verifier, code_challenge}) => {
        sessionStorage.setItem("outlook_pkce_verifier", code_verifier);
        sessionStorage.setItem("outlook_step", "imap");

        const redirect = encodeURIComponent(window.location.origin + "/oauth/callback/outlook");

        const scopes = encodeURIComponent([
          "offline_access",
          "https://outlook.office.com/.default"
        ].join(" "));

        window.location.href =
            `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize`
            + `?client_id=${clientId}`
            + `&response_type=code`
            + `&redirect_uri=${redirect}`
            + `&response_mode=query`
            + `&code_challenge=${code_challenge}`
            + `&code_challenge_method=S256`
            + `&scope=${scopes}`
            + `&state=${configId}`;
      });
    }
  }
};
</script>
